export enum LoginFormKey {
	GrantType = "grant_type",
	Scope = "scope",
	ClientId = "client_id",
	ClientSecret = "client_secret",
	Username = "username",
	Password = "password",
	Environment = "environment",
	Tenant = "tenant"
}